module.exports = __webpack_public_path__ + "static/media/meb.2580d506.jpg";